import Defaults from "./defaults";

export const readStoredSearchPayload = (searchKey) => {
  if (!searchKey) return {};

  const stored = sessionStorage.getItem(searchKey);
  if (!stored) return {};

  try {
    const parsed = JSON.parse(stored);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

export const readStoredSearchQuery = (searchKey) => {
  return readStoredSearchPayload(searchKey)?.query || {};
};

export const storedSearchText = (searchKey) => {
  const terms = readStoredSearchQuery(searchKey)?.TermsInclude;
  return terms?.length > 0 ? terms.join(" ") : "";
};

export const normalizeStoredSearchQuery = (q = {}) => ({
  termsInclude: q?.TermsInclude?.length > 0 ? q.TermsInclude : Defaults.search.termsInclude,
  termsExclude: q?.TermsExclude?.length > 0 ? q.TermsExclude : Defaults.search.termsExclude,
  industryInclude: q?.IndustryInclude?.length > 0 ? q.IndustryInclude : Defaults.search.industryInclude,
  industryExclude: q?.IndustryExclude?.length > 0 ? q.IndustryExclude : Defaults.search.industryExclude,
  locations: q?.Location?.length > 0 ? q.Location : Defaults.search.locations,
  revenueLowerBound: q?.RevenueLowerBound ?? Defaults.search.revenueLowerBound,
  revenueUpperBound: q?.RevenueUpperBound ?? Defaults.search.revenueUpperBound,
  employeesLowerBound: q?.EmployeesLowerBound ?? Defaults.search.employeesLowerBound,
  employeesUpperBound: q?.EmployeesUpperBound ?? Defaults.search.employeesUpperBound,
  naturalLanguageQuery: q?.NaturalLanguageQuery ?? Defaults.search.naturalLanguageQuery,
});
